import React from 'react';
import { useNavigate } from 'react-router-dom';

const NavigateLink: React.FC<{ to: string; content: string }> = ({
  to,
  content,
}) => {
  const navigate = useNavigate();

  return (
    <div className="mb-12">
      <a
        className="text-primary text-underline fs-18 fw-bold cursor-pointer"
        onClick={() => {
          navigate(to);
        }}
      >
        {content}
      </a>
    </div>
  );
};

export default NavigateLink;
